import { environment } from '../../environments/environment';

enum webActions {
    // Auth
    LOGIN = 'login',
    CHANGE_PASSWORD = 'changePwd',
    GETOTP = 'getOTP',
    LOGINWITHOTP = 'loginWithOTP',


    // Lists
    GETINVOICES = 'app/getInv',
    GETRIBBON = 'app/ribbon',
    GETTRANSACTIONS = 'app/payments',
    GETTRANSACTIONSDETAILS = 'app/paymentDetails',
    GET_CASHDISCOUNT_FOR_INVOICES_LIST = 'app/listEligibleCashDiscount',


    //Autopay
    SUBMIT_AUTOPAY = 'app/setPaymentSchedule',
    LIST_AUTOPAY = 'app/listPaymentSchedule',

    //Logo
    GET_LOGO = 'getLogo',
    
    // Payment
    PAYSETTINGS = 'app/paymentSettings',
    CREDIT_NOTES_PAYMENT = 'app/paymentCreditNotes',
    PAY_REASONS = 'app/payReasons',
    PAYMENT_OPTIONS = 'app/bankOptions',
    CASH_DISCOUNT = 'app/cashDiscount',
    GET_ELLIGIBLE_CASH_DISCOUNT = 'app/getEligibleCashDiscount',
    PAYMENT = 'app/payment',
    REJECT = 'app/rejectInvoice',
    REJECT_UPLOAD='dashboard/ledgerDocUpload',
    GET_REJECT_UPLOAD = 'app/getLedgerDocAttachments',
    GET_BUYER_CARDS = 'app/buyerCard',
    UPDATE_CARD = 'app/updateXiCard',
    UPDATE_CHECK = 'app/updateXiCheck',
    GET_CURRENCIES = 'app/currency',
    CREATE_RTP_LINK = 'app/createRequestToPay',
    GET_RTP_INFO = 'app/getRequestToPay',

    // View Invoice
    VIEWINVOICE = 'app/viewInvoice',

    // Other
    GETSELLERS = 'app/getSellers',
    VIRTUAL_DETAILS = 'app/virtualAccntDetails',

    // ADV Pay
    ADVPAYSETTINGS = 'app/advancePaySettings',
    ADVPAY = 'app/advancePay',
    ADVPAY_TYPE = 'app/advancePayTypes',

    // CN Used / Pending
    CREDIT_NOTES_LIST = 'app/creditNotes',

    // View statement
    VIEW_STATEMENT = 'app/viewStatement',

    // View statement only for Carlsberg
    VIEW_OUTSTANDING_STMT = 'app/outstandingStatement',

    //AUTOPAY
    SET_PAYMENT_SCHEDULE = 'app/setPaymentSchedule',
    DELETE_PAYMENT_SCHEDULE = 'app/deletePaymentSchedule',
    GET_PAYMENT_SCHEDULE_LIST = 'app/listPaymentSchedule',

    //get LOB
    LOB_LIST = 'app/getLOB',

    //get CN
    CN_LIST = 'app/getCNForLob',

    //assign CN to SD
    ASSIGN_CN_TO_SD ='app/assignCNToSD',

    // Manual Knock-off
    GET_INVOICES_FOR_MANUAL_KNOCKOFF = 'app/getInvoicesForPayment',
    PROCESS_MANUAL_KNOCKOFF = 'app/manualKnockOff',
    RTR_LINK = "app/rtrLink",

    // TODO - Remove lists of interfaces for current arch
    // Current arch,
    //App Settings
    GET_APP_VERSION = 'appVersion',

    GETOPT = 'mobile_auth',
    PIN_AUTH = 'pin_auth',
    GETTOKEN = 'otp_auth',
    GETRETAILER = 'user',

    CRNTLIST = 'credit_notes_list',
    DISTRIBUTORS = 'distributors',
    CHANGEPIN = 'change_pin',
    UPDATEPIN = 'updatePwd',
    REGISTERIBP = 'register_ibp',
    ADVANCE_PAY = 'advance_pay',
    DIVISION = 'division',
    PAY = 'pay',
    INVOICE_CD = 'CD_factor',
    INVOICE_CD_M = 'CD_factor_m',
    TRANSDETAIL = 'txn_desc',
    NEFT_BAL = 'neft_bal',
    NEFT_CRED_BAL = 'neft_credit_bal',
    V_ACC = 'v_acc',
    SCHEDULED_INVOICES = 'scheduled_invoices',
    DEFERRED_INVOICES = 'deferered_invoices',
    DEFERERED_INVOICES_REQUEST = 'deferered_invoices_request',
    CHECK_AUTO_SCHEDULE = 'auto_schedule_allowed',
    DEFERMENT_REQUEST = 'deferment_request',
    MULTIPAY_SETTINGS = 'multipay_settings',
    MANDATE = 'mandate',
    DISPUTE_INVOICE_REASONS = 'dispute_invoice_reasons',
    CPG_RETAILERS = 'cpg_retailers',
    DIVISION_OUTSTANDING = 'outstandings',
    RegisterIBP = 'neft_reg',
    APP_SETTINGS = 'appsettings',
    TRANSACTIONS = 'transactions',
    GET_ELOAN_LIMIT = 'get_EL_limit',
    UPDATE_PAYMENT_STATUS = 'update_status',
    GET_BANNERS = 'pending-banner',
    ACTION_BANNERS = 'banner-action',
    GET_VIDS_FOR_SCF = 'scf_vid',
    UPLOAD_COURIER_RECEIPT = 'uploadMtlsCc',
    GET_MULTIPAY_WITH_DEDUCTIONS = 'invoice-with-deduction',
    CHECKER_PENDING_TRANSACTIONS = 'awtingTrans',
    CHECKER_PROCESS_TRANSACTIONS = 'updateAwaitingTrans',
    CONFIRM_INVOICE_FOR_CD = 'confirm_cd',
    CALCULATE_DEFERMENT_INTEREST = 'calculate_deferment_interest',
    ENACH_MANDATES = 'mandates',
    REG_NEW_MANDATES = 'reg-mandates',
    PARTIAL_PAY_REASONS = 'partial_pay_reasons',
    WITHHOLD_PAY_REASONS = 'wht_config',
    // Current arch end.
    // View statement
    VIEW_ACC_STATEMENT = 'acctStatement',
    REJECTION_APPROVAL = 'app/rejectionApproval',
    REJECTED_INVOICE = 'app/getRejectedInv',
    PENDING_REJECTION_INV = 'app/getPendingRejectionInv',
    GET_BUYER_OPTIONS = 'app/getBuyerOptions',


    VIEW_INV_PATH = 'app/getInvViewURI',

    //Mange Payment Methods
    LIST_BUYER_PAYMENT_METHOD = 'app/listBuyerPaymentMethod',
    PAYMENT_METHOD_SELLER = 'app/paymentMethodSeller',
    GET_ADD_CARD_IFRAME = 'validateBuyerPaymentMethod',

    //Manage Auto Pay methods
    GET_LIST_OF_AUTO_PAY_METHODS = 'guest/buyer-data/getListOfAddedPaymentMethods'
}

const dummyResponse = {
    invoice: {"data":{"invoices":{"Transworld-2021031826":{"buyerCode":"TT27","docId":"2021031826","docNo":"2021031826","docDate":"12032021","dueDate":"05052021","dueAmt":46000.0,"docType":"INV","docRef":[{"type":"INV","docNo":"2021531704"}],"docAmt":86000.0,"docTypeDesc":"INV","status":"UNPAID","docViewPath":"http://13.235.178.169/invoices/transworld/2021031826","tags":[],"disablePay":false,"multipayTag":"TransworldTT27INV","sellerCode":"Transworld","ts":1616175982897,"groupId":null,"msg":{}},"Transworld-2021031827":{"buyerCode":"TT27","docId":"2021031827","docNo":"2021031826","docDate":"12032021","dueDate":"05052021","dueAmt":46000.0,"docType":"INV","docRef":[{"type":"INV","docNo":"2021531704"}],"docAmt":86000.0,"docTypeDesc":"INV","status":"UNPAID","docViewPath":"http://13.235.178.169/invoices/transworld/2021031826","tags":[],"disablePay":false,"multipayTag":"TransworldTT27INV","sellerCode":"Transworld","ts":1616175982897,"groupId":null,"msg":{}},"Transworld-2021031824":{"buyerCode":"TT27","docId":"2021031824","docNo":"2021531824","docDate":"12032021","dueDate":"05052021","dueAmt":44000.0,"docType":"INV","docRef":[{"type":"INV","docNo":"2021531704"}],"docAmt":84000.0,"docTypeDesc":"INV","status":"UNPAID","docViewPath":"http://13.235.178.169/invoices/transworld/2021531824","tags":[],"disablePay":false,"multipayTag":"TransworldTT27INV","sellerCode":"Transworld","ts":1616175982897,"groupId":null,"msg":{}},"Transworld-2021031825":{"buyerCode":"TT27","docId":"2021031825","docNo":"2021531825","docDate":"12032021","dueDate":"05052021","dueAmt":45000.0,"docType":"INV","docRef":[{"type":"INV","docNo":"2021531704"}],"docAmt":85000.0,"docTypeDesc":"INV","status":"UNPAID","docViewPath":"http://13.235.178.169/invoices/transworld/2021531825","tags":[],"disablePay":false,"multipayTag":"TransworldTT27INV","sellerCode":"Transworld","ts":1616175982897,"groupId":null,"msg":{}}},"invoiceOrder":["Transworld-2021031826","Transworld-2021031827","Transworld-2021031824","Transworld-2021031825"],"sellerConfig":{"Transworld":{"cnViewPath":"Data","viewStmt":true,"invPayByCN":true,"advPayment":true,"invViewPath":"Data","dnViewPath":"Data","dnPayByCN":true,"sellerNm":"Transworld","sellerImg":"Transworld","allowReject":true}},"groupConfig":{},"serverTime":1616175982897},"success":true,"msg":""}
}

const productItemHeading = {
    single: 'Invoice',
    multiple: 'Invoices',
    badgeLabel: 'Inv'
};

const currencySymbolConfig = {
    textualSymbol: 'USD',
    codeSymbol: '$'
}

// This is hardcoded in UI at the moment, need to get this from service
const transactionStatusMap = {
    'IN_BANK_QUEUE': { bgColor: '#90EE90', txtColor:'#000000' },
    'IN_BANK_PROC': { bgColor: '#90EE90', txtColor:'#000000' },
    'SUCCESS': { bgColor: '#006400', txtColor:'#ffff' },
    'FAILURE': { bgColor: '#f94449', txtColor:'#ffff' },
    'REJECTED': { bgColor: '#FB9868', txtColor:'#000000' },
    'DEFAULT': { bgColor: '#EDD26B', txtColor:'#000000' },
    'APPROVED': { bgColor: '#90EE90', txtColor:'#000000' },
    'FAILED': { bgColor: '#f94449', txtColor:'#ffff' }
}

const landingPageRouteConfig = {
    'knock-off': {url: 'invoices/knock-off', landingStateKey: 'knockOffData'},
    'otp-login': {url: 'signin'},
}

const dashboardServiceEndpoints = {
    LOGIN: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}auth/login`,
    GETSTATUSSTATS: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}stats/status`,
    GET_CURRENT_AR_SNAPSHOT: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}stats/current-ar-snapshot`,
    GET_CURRENT_RECON_BY_BUYER: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}stats/recon-summary-buyer`,
    GET_PAID_STATS: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}stats/paid-stats`,
    GET_BUYER_SUMMARY: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}stats/summary-buyer`,
    GET_SELLER_TOTAL_OUTSTANDING: `${environment.environmentConfig.DASHBOARD_SERVICE_API || ''}stats/seller-total-outstanding`,
}

export const Config = {
    webActions: webActions,
    dateFormat: 'DD-MMM-YYYY',
    dateSaveFormat: 'YYYY-MM-DD',
    dateServiceFormat: 'DD-MM-YYYY',
    defaultImage: 'assets/icon/default_cpg.png',
    productItemHeading: productItemHeading,
    sessionTimeout: {
        web: environment.environmentConfig.WEB_TIME_OUT || 43200000, // time in ms, 30 mins
        device: 604800000 // 7 days
    },
    maxIncorrectPinTries: 3,
    isOffline: true,
    forceOTP: false,
    environment_name: environment.environment_name,
    currencySymbolConfig: currencySymbolConfig,
    transactionStatusMap,
    landingPageRouteConfig,
    dummyResponse,
    mimeTypeMap: {
        'pdf': 'application/pdf',
        'txt': 'text/plain',
        'html': 'text/html',
        'htm': 'text/html',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'doc': 'application/msword',
        'jpg': 'image/jpeg',
        'bmp': 'image/bmp',
        'png': 'image/png',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    ext_bank_options: {
        neft: {
            title: 'NEFT/RTGS Transfer',
            umrn_number: 'NEFT',
            isNEFT: true,
            isExtPay: true,
            sortTitle: 'NEFT'
        },
        ibp: {
            title: 'PayEX IBP ICICI',
            umrn_number: 'ANEFT',
            isNEFT: false,
            isExtPay: true
        }
    },
    min_pin_length: environment.environmentConfig.MIN_PIN_LENGTH || 4,
    max_pin_length: environment.environmentConfig.MAX_PIN_LENGTH || 6,
    appName: environment.appName,
    transformNWCalls: environment.environmentConfig.TRANSFORM_NW_CALL || false,
    transformNWCallsDevice: environment.environmentConfig.TRANSFORM_NW_CALL_DEVICE || false,
    addDeviceInfoToHeaders: environment.environmentConfig.ADD_DEVICE_INFO || false,
    transformParam: environment.environmentConfig.TRANSFORM_PARAM || '',
    dashboardServiceURL: environment.environmentConfig.DASHBOARD_SERVICE_API || '',
    defaultCurr: environment.environmentConfig.DEFAULT_CURR || 'INR',
    secondaryCurr: environment.environmentConfig.SECONDARY_CURR || 'EUR',
    dashboardServiceEndpoints,
    useProxyForLogo: environment.environmentConfig.USE_PROXY_FOR_LOGO || false,
    proxyForLogoURL: environment.environmentConfig.PROXY_FOR_LOGO_URL || ''
};
